import { Pipe, PipeTransform } from '@angular/core';
import { ChatMessageTypeEnum, XpressUserRoleEnum } from 'app/models';

@Pipe({
  name: 'getChatMessageType',
})
export class GetChatMessageTypePipe implements PipeTransform {
  transform(chatMessage: any, xpressUserRoleId: any): boolean {
    if (xpressUserRoleId === XpressUserRoleEnum.Merchant) {
      if (
        chatMessage.MessageTypeId === ChatMessageTypeEnum.MerchantToSupport ||
        chatMessage.MessageTypeId === ChatMessageTypeEnum.MerchantToCustomer
      ) {
        return true;
      }
      return false;
    }

    if (
      chatMessage.MessageTypeId === ChatMessageTypeEnum.SupportToCustomer ||
      chatMessage.MessageTypeId === ChatMessageTypeEnum.SupportToMerchant
    ) {
      return true;
    }
    return false;
  }
}
